import { useParams } from "react-router-dom";

export const Loan = () => {
    let params = useParams();
    console.log('loan');
    return (
        <div className='content'>Loan {params.id}</div>
    )
};